import type { components } from '#/api/schema'
import { isRecord } from '#/utils/typeGuards'

export type TCodedErrorCode = components['schemas']['CodedErrorResponse']['code']

/** Typed against the generated 409 union so a new code fails the build here. */
export const PERSON_CREATE_ERROR_MESSAGES: Record<TCodedErrorCode, string> = {
  USER_ALREADY_EXISTS: 'A user with this email address already exists.',
  USER_MS_LINK_NOT_FOUND: 'The email address was not found in userMS, so it cannot be linked.',
  EMAIL_REQUIRED: 'Enter an email address, or tick that this person has none',
}

export function extractApiErrorMessage(error: unknown): string | null {
  if (typeof error === 'string' && error !== '') return error

  if (!isRecord(error)) {
    if (error instanceof Error && error.message !== '') return error.message

    return null
  }

  const candidates = [error.message, error.detail, error['hydra:description'], error.title]
  for (const candidate of candidates) if (typeof candidate === 'string' && candidate !== '') return candidate

  if ('error' in error) return extractApiErrorMessage(error.error)

  return null
}

export function extractApiErrorCode(error: unknown): string | null {
  if (!isRecord(error)) return null

  if (typeof error.code === 'string' && error.code !== '') return error.code

  if ('error' in error) return extractApiErrorCode(error.error)

  return null
}

export function isPersonCreateErrorCode(value: string): value is TCodedErrorCode {
  return Object.hasOwn(PERSON_CREATE_ERROR_MESSAGES, value)
}

export function personCreateErrorMessage(code: string | null): string | null {
  if (code === null || !isPersonCreateErrorCode(code)) return null

  return PERSON_CREATE_ERROR_MESSAGES[code]
}
